let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bSLko")).then(() => parcelRequire('f920Z'));